import { render } from "./StickyScrollATable.vue?vue&type=template&id=e99e3e04&scoped=true"
import script from "./StickyScrollATable.vue?vue&type=script&lang=js"
export * from "./StickyScrollATable.vue?vue&type=script&lang=js"

import "./StickyScrollATable.vue?vue&type=style&index=0&id=e99e3e04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e99e3e04"]])

export default __exports__